import { CommercialBenefits } from '@tenants';

export const benefitsConfig: CommercialBenefits = {
  joinUsLink: 'https://joinapp.expcommercial.com/',
  benefits: [
    {
      type: 'card',
      title: '',
      titleHtml: 'Nationwide <br /> Collaboration',
      description: 'With our national footprint, advisors can collaborate, co-broker and expand across the country.',
    },
    {
      type: 'image',
      url: '/next/assets/images/exp-commercial/benifits-stock-1.webp',
      altText: 'Modern office skyscrapers in downtown cityscape, viewed from below in black and white.',
    },
    {
      type: 'card',
      title: 'Ownership',
      description: 'With equity awards and revenue share, our model rewards advisors’ growth and success.',
    },
    {
      type: 'image',
      url: '/next/assets/images/exp-commercial/benifits-stock-4.webp',
      altText: 'Confident young professional using smartphone outside modern office building.',
    },
    {
      type: 'card',
      title: 'Freedom',
      description: 'Our platform gives advisors and entrepreneurs full autonomy to build your own brand without franchise limits or employee constraints.',
    },
    {
      type: 'image',
      url: '/next/assets/images/exp-commercial/benifits-stock-3.webp',
      altText: 'Upward view of tall city skyscrapers surrounding the sun on a bright day, with reflections on the glass buildings.',
    },
    {
      type: 'card',
      title: 'Growth',
      description: 'With top-tier training, live masterminds and on-demand education, advisors have the tools to grow their business and income.',
    },
    {
      type: 'image',
      url: '/next/assets/images/exp-commercial/benifits-stock-2.webp',
      altText: 'Real estate agents touring a modern property development, discussing opportunities in an urban neighborhood.',
    },
  ] as const,
};
